
// export interface UsersPage {
//   columns?: Column[];
//   userstableData?: UsersTableData[];
// }
// export interface Columns {
//   label: string;
//   name: string;
//   filterPlaceHolder?: string;
//   filterOptions?: [];
//   validations?: [];
//   orgEta?: boolean;
// }
export interface UsersTableData {
  // map(arg0: (item: UsersTableData) => UsersTableData): unknown;
  alternativeEmail?: string;
  cpmpany?: string;
  displayName?: string;
  email?: string;
  legalEntityCount?: number;
  // additional properties
  legalEntityList?: [];
  legalEntityNames?: string[];
  userId?: string;
}
export interface B2BCustomers {
  b2bCustomers: UsersTableData[];
}
export interface QueryParam {
  fields?: string;
  pageSize?: number;
  currentPage?: number;
}
export interface ParamsObject {
  fields?: string;
  pageSize?: number;
  currentPage?: number;
  userID?: string;
}

export enum UserTableColumn {
  DISPLAY_NAME = 'displayName',
  EMAIL = 'email',
  ALTERNATIVE_EMAIL = 'alternativeEmail',
  COMPANY = 'company',
  LEGAL_ENTITY_COUNT = 'legalEntityCount',
}

export enum UserTableColumnHeader {
  NAME = 'Name',
  USER_NAME = 'Username',
  ALTERNATIVE_EMAIL = 'Alternative Email',
  COMPANY = 'Company',
  LEGAL_ENTITIES = 'Legal Entities',
}


export enum User {
  USER = 'user',
  BASIC = 'BASIC',
  USERS = 'Users',
  CSV = 'csv',
  CSV_TEXT = 'text/csv'

}
export interface MapLegalEntityData {
  uid?: string;
  legalEntityCount?: string;
}
export interface LegalEntity {
  uid?: string | number;
  name?: string;
  isSelected?: boolean;
  members?: [];
  membersCount?: number;
  minOrderAmount?: number;
  roles?: [];
}

export enum CSVHeaders {
  NAME = 'Name',
  USER_NAME = 'Username',
  ALTERNATIVE_EMAIL = 'AlternativeEmail',
  COMPANY = 'Company',
  LEGAL_ENTITIES = 'LegalEntities',
}

export enum Document {
  DOWNLOAD = 'document.download',
  NAME = 'Users.csv',
}
